var _desc, _defs, _rect, _clipPath, _clipPath2, _clipPath3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatisticsIconDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "#0f2239"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.818 0 0 1.818 499.9545 500.9545)",
    id: 267100
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -11.9774 -6.4753)",
    id: "freepik--background-simple--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(57,153,248)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-238.0225, -243.5247)",
    d: "M 77.72 333.84 c 57 50.17 107.91 50.67 179.92 54.78 s 122.32 -12 155.76 -51.33 C 452 291.9 438.22 201.43 366.81 178.05 c -22.32 -7.32 -47.69 -7.07 -68 -18.84 c -38.68 -22.47 -72.66 -60.92 -130 -61.4 s -90.32 42.38 -90.32 42.38 C 39 197 20.7 283.67 77.72 333.84 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -11.9774 -6.4753)",
    id: "freepik--background-simple--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.7
    },
    transform: " translate(-238.0225, -243.5247)",
    d: "M 77.72 333.84 c 57 50.17 107.91 50.67 179.92 54.78 s 122.32 -12 155.76 -51.33 C 452 291.9 438.22 201.43 366.81 178.05 c -22.32 -7.32 -47.69 -7.07 -68 -18.84 c -38.68 -22.47 -72.66 -60.92 -130 -61.4 s -90.32 42.38 -90.32 42.38 C 39 197 20.7 283.67 77.72 333.84 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -15.41 170.38)",
    id: "freepik--shadow--inject-99"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(57,153,248)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    rx: 156.32,
    ry: 7.84
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -15.41 170.38)",
    id: "freepik--shadow--inject-99"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.7
    },
    cx: 0,
    cy: 0,
    rx: 156.32,
    ry: 7.84
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 168.57 181.44)",
    id: "freepik--shadow--inject-99"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(57,153,248)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    rx: 30.43,
    ry: 6.91
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 168.57 181.44)",
    id: "freepik--shadow--inject-99"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.7
    },
    cx: 0,
    cy: 0,
    rx: 30.43,
    ry: 6.91
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -132.7837 108.7335)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(57,153,248)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-117.2163, -358.7334)",
    d: "M 140.17 397.79 c -1.39 -2.15 -3.31 -5.26 -5.53 -9.08 c -0.63 -1.1 -1.27 -2.27 -1.92 -3.49 c 0.47 -0.3 4.33 -2.74 5.53 -4.54 c 1.11 -1.61 2 -4 1.3 -5.92 a 3.45 3.45 0 0 0 -4.32 -2.25 l -0.35 0.13 c -2.64 1.25 -3.5 6.43 -3.17 9 c 0 0.15 0.5 2.08 0.76 3.06 l -1.18 -2.21 c -0.57 -1.11 -1.11 -2.3 -1.71 -3.44 l -0.82 -1.85 c -0.29 -0.62 -0.5 -1.24 -0.75 -1.87 c -0.35 -0.93 -0.67 -1.91 -1 -2.89 c 1.11 -0.52 4.56 -2.1 5.82 -3.49 s 2.56 -3.64 2.21 -5.67 a 3.45 3.45 0 0 0 -3.92 -2.88 l -0.38 0.08 c -2.79 0.83 -4.43 5.82 -4.49 8.42 a 9.11 9.11 0 0 0 0.1 1.3 c -0.28 -1 -0.57 -1.93 -0.82 -2.91 c -0.72 -2.8 -1.36 -5.67 -2 -8.53 c -0.13 -0.6 -0.27 -1.2 -0.42 -1.79 c 1 -0.43 4.67 -2.13 6 -3.59 s 2.57 -3.64 2.21 -5.66 a 3.46 3.46 0 0 0 -3.94 -2.88 l -0.36 0.08 c -2.79 0.83 -4.43 5.83 -4.49 8.43 c 0 0.09 0 0.75 0.12 1.48 c -0.38 -1.55 -0.78 -3.1 -1.22 -4.62 a 62.49 62.49 0 0 0 -2.75 -7.67 c 0.35 -0.14 4.71 -2 6.18 -3.66 c 1.31 -1.44 2.57 -3.64 2.21 -5.65 a 3.45 3.45 0 0 0 -3.93 -2.89 a 2.21 2.21 0 0 0 -0.37 0.08 c -2.79 0.83 -4.42 5.83 -4.49 8.43 c 0 0.17 0.21 2.55 0.32 3.4 v -0.08 a 45.84 45.84 0 0 0 -4 -6.93 a 64.57 64.57 0 0 0 -4.43 -5.61 c -1.45 -1.67 -2.88 -3.11 -4.15 -4.42 c -0.7 -0.68 -1.35 -1.29 -2 -1.85 h 0 s -1.36 -3.25 -1.47 -3.45 c -1.3 -2.22 -5.14 -5.83 -8 -5.21 a 3.44 3.44 0 0 0 -2.52 4.16 c 0 0.12 0.07 0.24 0.11 0.36 c 0.63 2 2.8 3.32 4.64 3.92 s 6 0.33 7 0.24 c 0.62 0.6 1.28 1.24 2 2 c 1.24 1.29 2.64 2.75 4 4.42 c 0.38 0.45 0.76 1 1.11 1.43 c -0.82 -0.67 -1.95 -1.58 -2.07 -1.66 c -2.21 -1.39 -7.26 -2.8 -9.49 -0.94 a 3.43 3.43 0 0 0 -0.34 4.85 a 1.79 1.79 0 0 0 0.27 0.28 c 1.47 1.44 4 1.62 5.92 1.33 s 5.53 -2.53 6.37 -3 c 0.83 1.11 1.66 2.21 2.46 3.42 a 44.64 44.64 0 0 1 3.8 6.91 c 0.06 0.14 0.1 0.29 0.17 0.43 c -0.34 -0.39 -2.39 -2.46 -2.56 -2.6 c -2 -1.62 -6.9 -3.58 -9.33 -2 a 3.47 3.47 0 0 0 -0.84 4.83 a 2.88 2.88 0 0 0 0.22 0.27 c 1.29 1.6 3.79 2 5.73 2 c 2.21 -0.07 6.64 -2.3 6.81 -2.39 a 58.56 58.56 0 0 1 2.49 7.48 c 0.51 1.87 0.94 3.8 1.35 5.73 c -0.45 -0.51 -2.36 -2.43 -2.51 -2.55 c -2 -1.63 -6.9 -3.59 -9.34 -2 a 3.45 3.45 0 0 0 -0.86 4.8 l 0.23 0.3 c 1.31 1.59 3.8 2 5.74 2 c 2.22 -0.08 6.42 -2.22 6.77 -2.37 c 0.19 0.87 0.39 1.76 0.57 2.63 c 0.6 2.89 1.18 5.78 1.85 8.61 c 0.22 1 0.48 2 0.74 2.91 c -0.71 -0.75 -2 -2.08 -2.16 -2.21 c -2 -1.64 -6.91 -3.59 -9.34 -2 a 3.46 3.46 0 0 0 -0.86 4.81 a 3.25 3.25 0 0 0 0.23 0.29 c 1.31 1.6 3.8 2.05 5.74 2 s 5.54 -1.77 6.55 -2.21 c 0.45 1.59 0.92 3.18 1.46 4.7 c 0.26 0.66 0.47 1.34 0.73 2 s 0.52 1.25 0.79 1.86 c 0.57 1.25 1.1 2.41 1.67 3.56 c 0.28 0.58 0.56 1.11 0.84 1.68 c -0.61 -0.86 -1.59 -2.21 -1.7 -2.32 c -1.76 -1.93 -6.29 -4.59 -8.93 -3.38 a 3.44 3.44 0 0 0 -1.58 4.61 c 0 0.11 0.12 0.22 0.18 0.33 c 1.11 1.78 3.45 2.6 5.38 2.82 c 2.13 0.25 6.5 -1.11 7 -1.31 c 0.69 1.38 1.38 2.7 2 3.94 c 2.12 3.91 4 7.07 5.38 9.28 s 2.21 3.44 2.21 3.44 h 0 a 1 1 0 0 0 1.43 0.25 a 1 1 0 0 0 0.25 -1.42 h 0 S 141.58 399.93 140.17 397.79 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -136.157 74.906)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(57,153,248)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-113.843, -324.906)",
    d: "M 111.61 331.53 s 4 -3.17 5.06 -5.21 c 0.87 -1.72 1.5 -4.18 0.59 -6 a 3.44 3.44 0 0 0 -4.54 -1.74 l -0.34 0.17 c -2.47 1.54 -2.74 6.79 -2.11 9.32 C 110.36 328.26 111.61 331.56 111.61 331.53 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -152.4294 127.4427)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(57,153,248)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-97.5707, -377.4427)",
    d: "M 137.88 399.67 c -2.34 -1 -5.68 -2.53 -9.6 -4.52 c -1.1 -0.57 -2.32 -1.19 -3.54 -1.86 c 0.25 -0.5 2.11 -4.67 2.1 -6.82 c 0 -1.94 -0.54 -4.43 -2.21 -5.65 a 3.44 3.44 0 0 0 -4.84 0.49 l -0.23 0.31 c -1.51 2.5 0.62 7.3 2.33 9.26 c 0.11 0.14 1.57 1.47 2.32 2.15 L 122 391.81 c -1.11 -0.61 -2.21 -1.28 -3.32 -1.93 L 117 388.77 c -0.59 -0.35 -1.11 -0.76 -1.66 -1.11 c -0.81 -0.57 -1.62 -1.21 -2.41 -1.85 c 0.68 -1.11 2.63 -4.27 2.92 -6.13 s 0.12 -4.43 -1.31 -5.92 a 3.45 3.45 0 0 0 -4.86 -0.28 a 3.57 3.57 0 0 0 -0.27 0.28 c -1.87 2.21 -0.49 7.3 0.89 9.5 a 9.66 9.66 0 0 0 0.8 1 c -0.76 -0.65 -1.54 -1.3 -2.29 -2 c -2.13 -1.94 -4.26 -4 -6.38 -6 L 101.07 375 c 0.58 -0.89 2.73 -4.34 3 -6.28 s 0.12 -4.43 -1.31 -5.93 a 3.44 3.44 0 0 0 -4.87 -0.26 l -0.26 0.26 c -1.87 2.21 -0.49 7.31 0.9 9.51 a 10.43 10.43 0 0 0 0.91 1.17 c -1.17 -1.09 -2.36 -2.16 -3.56 -3.18 a 60.81 60.81 0 0 0 -6.52 -4.88 c 0.21 -0.32 2.81 -4.29 3.14 -6.46 c 0.29 -1.93 0.12 -4.43 -1.31 -5.93 a 3.45 3.45 0 0 0 -4.89 -0.24 l -0.24 0.24 c -1.87 2.21 -0.49 7.31 0.89 9.51 c 0.1 0.16 1.6 2 2.15 2.67 l -0.08 -0.06 a 45.37 45.37 0 0 0 -7.15 -3.56 a 64 64 0 0 0 -6.79 -2.21 c -2.13 -0.6 -4.12 -1 -5.88 -1.36 c -1 -0.18 -1.83 -0.33 -2.64 -0.47 h 0 s -2.94 -1.95 -3.14 -2.05 c -2.32 -1.16 -7.51 -2 -9.54 0.05 a 3.46 3.46 0 0 0 0.2 4.88 l 0.28 0.23 c 1.61 1.29 4.14 1.19 6 0.71 s 5.19 -3 6 -3.67 c 0.85 0.15 1.76 0.33 2.75 0.54 c 1.75 0.39 3.72 0.84 5.83 1.48 c 0.57 0.17 1.11 0.38 1.74 0.56 c -1 -0.11 -2.49 -0.25 -2.62 -0.24 c -2.61 0 -7.6 1.66 -8.45 4.43 a 3.43 3.43 0 0 0 2.42 4.23 a 2.33 2.33 0 0 0 0.36 0.08 c 2 0.4 4.23 -0.85 5.67 -2.21 s 3.32 -5.2 3.64 -6 c 1.28 0.43 2.6 0.91 3.93 1.49 a 43.91 43.91 0 0 1 7 3.67 L 89 366 c -0.51 -0.14 -3.32 -0.74 -3.55 -0.76 c -2.6 -0.23 -7.74 0.82 -8.85 3.51 a 3.44 3.44 0 0 0 2 4.47 a 3.4 3.4 0 0 0 0.34 0.12 c 2 0.61 4.29 -0.39 5.87 -1.52 c 1.82 -1.3 4.27 -5.6 4.36 -5.75 a 60.45 60.45 0 0 1 6.2 4.85 c 1.46 1.3 2.89 2.66 4.3 4 c -0.67 -0.16 -3.32 -0.72 -3.52 -0.74 c -2.58 -0.24 -7.74 0.82 -8.85 3.5 a 3.45 3.45 0 0 0 1.93 4.47 l 0.36 0.12 c 2 0.62 4.3 -0.38 5.88 -1.52 c 1.77 -1.27 4.14 -5.36 4.33 -5.71 l 1.93 1.9 c 2.09 2.06 4.17 4.16 6.28 6.15 c 0.73 0.69 1.49 1.35 2.22 2 c -1 -0.23 -2.85 -0.61 -3 -0.63 c -2.6 -0.23 -7.75 0.83 -8.85 3.51 a 3.44 3.44 0 0 0 1.92 4.47 l 0.37 0.12 c 2 0.61 4.29 -0.39 5.87 -1.52 s 3.65 -4.53 4.22 -5.53 c 1.25 1.11 2.51 2.15 3.8 3.12 c 0.58 0.41 1.11 0.86 1.69 1.23 l 1.68 1.1 c 1.17 0.72 2.21 1.4 3.31 2.05 l 1.63 0.94 c -1 -0.39 -2.56 -1 -2.7 -1 c -2.53 -0.63 -7.74 -0.36 -9.31 2.12 a 3.45 3.45 0 0 0 1.24 4.72 a 2.55 2.55 0 0 0 0.33 0.17 c 1.84 0.89 4.3 0.26 6 -0.61 c 1.91 -1 4.79 -4.54 5.14 -5 c 1.34 0.77 2.64 1.5 3.88 2.15 c 3.91 2.09 7.25 3.69 9.61 4.78 s 3.72 1.66 3.72 1.66 h 0 a 1 1 0 0 0 0.73 -1.92 S 140.24 400.67 137.88 399.67 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -175.1443 103.6362)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(57,153,248)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-74.8557, -353.6362)",
    d: "M 77.54 360.15 s 1.6 -4.86 1.34 -7.12 c -0.23 -1.94 -1.11 -4.33 -2.82 -5.37 a 3.46 3.46 0 0 0 -4.77 1.06 a 2.58 2.58 0 0 0 -0.18 0.32 c -1.22 2.66 1.46 7.18 3.39 8.93 C 74.66 358.13 77.53 360.21 77.54 360.15 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -132.7837 108.7335)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.4
    },
    transform: " translate(-117.2163, -358.7334)",
    d: "M 140.17 397.79 c -1.39 -2.15 -3.31 -5.26 -5.53 -9.08 c -0.63 -1.1 -1.27 -2.27 -1.92 -3.49 c 0.47 -0.3 4.33 -2.74 5.53 -4.54 c 1.11 -1.61 2 -4 1.3 -5.92 a 3.45 3.45 0 0 0 -4.32 -2.25 l -0.35 0.13 c -2.64 1.25 -3.5 6.43 -3.17 9 c 0 0.15 0.5 2.08 0.76 3.06 l -1.18 -2.21 c -0.57 -1.11 -1.11 -2.3 -1.71 -3.44 l -0.82 -1.85 c -0.29 -0.62 -0.5 -1.24 -0.75 -1.87 c -0.35 -0.93 -0.67 -1.91 -1 -2.89 c 1.11 -0.52 4.56 -2.1 5.82 -3.49 s 2.56 -3.64 2.21 -5.67 a 3.45 3.45 0 0 0 -3.92 -2.88 l -0.38 0.08 c -2.79 0.83 -4.43 5.82 -4.49 8.42 a 9.11 9.11 0 0 0 0.1 1.3 c -0.28 -1 -0.57 -1.93 -0.82 -2.91 c -0.72 -2.8 -1.36 -5.67 -2 -8.53 c -0.13 -0.6 -0.27 -1.2 -0.42 -1.79 c 1 -0.43 4.67 -2.13 6 -3.59 s 2.57 -3.64 2.21 -5.66 a 3.46 3.46 0 0 0 -3.94 -2.88 l -0.36 0.08 c -2.79 0.83 -4.43 5.83 -4.49 8.43 c 0 0.09 0 0.75 0.12 1.48 c -0.38 -1.55 -0.78 -3.1 -1.22 -4.62 a 62.49 62.49 0 0 0 -2.75 -7.67 c 0.35 -0.14 4.71 -2 6.18 -3.66 c 1.31 -1.44 2.57 -3.64 2.21 -5.65 a 3.45 3.45 0 0 0 -3.93 -2.89 a 2.21 2.21 0 0 0 -0.37 0.08 c -2.79 0.83 -4.42 5.83 -4.49 8.43 c 0 0.17 0.21 2.55 0.32 3.4 v -0.08 a 45.84 45.84 0 0 0 -4 -6.93 a 64.57 64.57 0 0 0 -4.43 -5.61 c -1.45 -1.67 -2.88 -3.11 -4.15 -4.42 c -0.7 -0.68 -1.35 -1.29 -2 -1.85 h 0 s -1.36 -3.25 -1.47 -3.45 c -1.3 -2.22 -5.14 -5.83 -8 -5.21 a 3.44 3.44 0 0 0 -2.52 4.16 c 0 0.12 0.07 0.24 0.11 0.36 c 0.63 2 2.8 3.32 4.64 3.92 s 6 0.33 7 0.24 c 0.62 0.6 1.28 1.24 2 2 c 1.24 1.29 2.64 2.75 4 4.42 c 0.38 0.45 0.76 1 1.11 1.43 c -0.82 -0.67 -1.95 -1.58 -2.07 -1.66 c -2.21 -1.39 -7.26 -2.8 -9.49 -0.94 a 3.43 3.43 0 0 0 -0.34 4.85 a 1.79 1.79 0 0 0 0.27 0.28 c 1.47 1.44 4 1.62 5.92 1.33 s 5.53 -2.53 6.37 -3 c 0.83 1.11 1.66 2.21 2.46 3.42 a 44.64 44.64 0 0 1 3.8 6.91 c 0.06 0.14 0.1 0.29 0.17 0.43 c -0.34 -0.39 -2.39 -2.46 -2.56 -2.6 c -2 -1.62 -6.9 -3.58 -9.33 -2 a 3.47 3.47 0 0 0 -0.84 4.83 a 2.88 2.88 0 0 0 0.22 0.27 c 1.29 1.6 3.79 2 5.73 2 c 2.21 -0.07 6.64 -2.3 6.81 -2.39 a 58.56 58.56 0 0 1 2.49 7.48 c 0.51 1.87 0.94 3.8 1.35 5.73 c -0.45 -0.51 -2.36 -2.43 -2.51 -2.55 c -2 -1.63 -6.9 -3.59 -9.34 -2 a 3.45 3.45 0 0 0 -0.86 4.8 l 0.23 0.3 c 1.31 1.59 3.8 2 5.74 2 c 2.22 -0.08 6.42 -2.22 6.77 -2.37 c 0.19 0.87 0.39 1.76 0.57 2.63 c 0.6 2.89 1.18 5.78 1.85 8.61 c 0.22 1 0.48 2 0.74 2.91 c -0.71 -0.75 -2 -2.08 -2.16 -2.21 c -2 -1.64 -6.91 -3.59 -9.34 -2 a 3.46 3.46 0 0 0 -0.86 4.81 a 3.25 3.25 0 0 0 0.23 0.29 c 1.31 1.6 3.8 2.05 5.74 2 s 5.54 -1.77 6.55 -2.21 c 0.45 1.59 0.92 3.18 1.46 4.7 c 0.26 0.66 0.47 1.34 0.73 2 s 0.52 1.25 0.79 1.86 c 0.57 1.25 1.1 2.41 1.67 3.56 c 0.28 0.58 0.56 1.11 0.84 1.68 c -0.61 -0.86 -1.59 -2.21 -1.7 -2.32 c -1.76 -1.93 -6.29 -4.59 -8.93 -3.38 a 3.44 3.44 0 0 0 -1.58 4.61 c 0 0.11 0.12 0.22 0.18 0.33 c 1.11 1.78 3.45 2.6 5.38 2.82 c 2.13 0.25 6.5 -1.11 7 -1.31 c 0.69 1.38 1.38 2.7 2 3.94 c 2.12 3.91 4 7.07 5.38 9.28 s 2.21 3.44 2.21 3.44 h 0 a 1 1 0 0 0 1.43 0.25 a 1 1 0 0 0 0.25 -1.42 h 0 S 141.58 399.93 140.17 397.79 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -136.157 74.906)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.4
    },
    transform: " translate(-113.843, -324.906)",
    d: "M 111.61 331.53 s 4 -3.17 5.06 -5.21 c 0.87 -1.72 1.5 -4.18 0.59 -6 a 3.44 3.44 0 0 0 -4.54 -1.74 l -0.34 0.17 c -2.47 1.54 -2.74 6.79 -2.11 9.32 C 110.36 328.26 111.61 331.56 111.61 331.53 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -152.4294 127.4427)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.4
    },
    transform: " translate(-97.5707, -377.4427)",
    d: "M 137.88 399.67 c -2.34 -1 -5.68 -2.53 -9.6 -4.52 c -1.1 -0.57 -2.32 -1.19 -3.54 -1.86 c 0.25 -0.5 2.11 -4.67 2.1 -6.82 c 0 -1.94 -0.54 -4.43 -2.21 -5.65 a 3.44 3.44 0 0 0 -4.84 0.49 l -0.23 0.31 c -1.51 2.5 0.62 7.3 2.33 9.26 c 0.11 0.14 1.57 1.47 2.32 2.15 L 122 391.81 c -1.11 -0.61 -2.21 -1.28 -3.32 -1.93 L 117 388.77 c -0.59 -0.35 -1.11 -0.76 -1.66 -1.11 c -0.81 -0.57 -1.62 -1.21 -2.41 -1.85 c 0.68 -1.11 2.63 -4.27 2.92 -6.13 s 0.12 -4.43 -1.31 -5.92 a 3.45 3.45 0 0 0 -4.86 -0.28 a 3.57 3.57 0 0 0 -0.27 0.28 c -1.87 2.21 -0.49 7.3 0.89 9.5 a 9.66 9.66 0 0 0 0.8 1 c -0.76 -0.65 -1.54 -1.3 -2.29 -2 c -2.13 -1.94 -4.26 -4 -6.38 -6 L 101.07 375 c 0.58 -0.89 2.73 -4.34 3 -6.28 s 0.12 -4.43 -1.31 -5.93 a 3.44 3.44 0 0 0 -4.87 -0.26 l -0.26 0.26 c -1.87 2.21 -0.49 7.31 0.9 9.51 a 10.43 10.43 0 0 0 0.91 1.17 c -1.17 -1.09 -2.36 -2.16 -3.56 -3.18 a 60.81 60.81 0 0 0 -6.52 -4.88 c 0.21 -0.32 2.81 -4.29 3.14 -6.46 c 0.29 -1.93 0.12 -4.43 -1.31 -5.93 a 3.45 3.45 0 0 0 -4.89 -0.24 l -0.24 0.24 c -1.87 2.21 -0.49 7.31 0.89 9.51 c 0.1 0.16 1.6 2 2.15 2.67 l -0.08 -0.06 a 45.37 45.37 0 0 0 -7.15 -3.56 a 64 64 0 0 0 -6.79 -2.21 c -2.13 -0.6 -4.12 -1 -5.88 -1.36 c -1 -0.18 -1.83 -0.33 -2.64 -0.47 h 0 s -2.94 -1.95 -3.14 -2.05 c -2.32 -1.16 -7.51 -2 -9.54 0.05 a 3.46 3.46 0 0 0 0.2 4.88 l 0.28 0.23 c 1.61 1.29 4.14 1.19 6 0.71 s 5.19 -3 6 -3.67 c 0.85 0.15 1.76 0.33 2.75 0.54 c 1.75 0.39 3.72 0.84 5.83 1.48 c 0.57 0.17 1.11 0.38 1.74 0.56 c -1 -0.11 -2.49 -0.25 -2.62 -0.24 c -2.61 0 -7.6 1.66 -8.45 4.43 a 3.43 3.43 0 0 0 2.42 4.23 a 2.33 2.33 0 0 0 0.36 0.08 c 2 0.4 4.23 -0.85 5.67 -2.21 s 3.32 -5.2 3.64 -6 c 1.28 0.43 2.6 0.91 3.93 1.49 a 43.91 43.91 0 0 1 7 3.67 L 89 366 c -0.51 -0.14 -3.32 -0.74 -3.55 -0.76 c -2.6 -0.23 -7.74 0.82 -8.85 3.51 a 3.44 3.44 0 0 0 2 4.47 a 3.4 3.4 0 0 0 0.34 0.12 c 2 0.61 4.29 -0.39 5.87 -1.52 c 1.82 -1.3 4.27 -5.6 4.36 -5.75 a 60.45 60.45 0 0 1 6.2 4.85 c 1.46 1.3 2.89 2.66 4.3 4 c -0.67 -0.16 -3.32 -0.72 -3.52 -0.74 c -2.58 -0.24 -7.74 0.82 -8.85 3.5 a 3.45 3.45 0 0 0 1.93 4.47 l 0.36 0.12 c 2 0.62 4.3 -0.38 5.88 -1.52 c 1.77 -1.27 4.14 -5.36 4.33 -5.71 l 1.93 1.9 c 2.09 2.06 4.17 4.16 6.28 6.15 c 0.73 0.69 1.49 1.35 2.22 2 c -1 -0.23 -2.85 -0.61 -3 -0.63 c -2.6 -0.23 -7.75 0.83 -8.85 3.51 a 3.44 3.44 0 0 0 1.92 4.47 l 0.37 0.12 c 2 0.61 4.29 -0.39 5.87 -1.52 s 3.65 -4.53 4.22 -5.53 c 1.25 1.11 2.51 2.15 3.8 3.12 c 0.58 0.41 1.11 0.86 1.69 1.23 l 1.68 1.1 c 1.17 0.72 2.21 1.4 3.31 2.05 l 1.63 0.94 c -1 -0.39 -2.56 -1 -2.7 -1 c -2.53 -0.63 -7.74 -0.36 -9.31 2.12 a 3.45 3.45 0 0 0 1.24 4.72 a 2.55 2.55 0 0 0 0.33 0.17 c 1.84 0.89 4.3 0.26 6 -0.61 c 1.91 -1 4.79 -4.54 5.14 -5 c 1.34 0.77 2.64 1.5 3.88 2.15 c 3.91 2.09 7.25 3.69 9.61 4.78 s 3.72 1.66 3.72 1.66 h 0 a 1 1 0 0 0 0.73 -1.92 S 140.24 400.67 137.88 399.67 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -175.1443 103.6362)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.4
    },
    transform: " translate(-74.8557, -353.6362)",
    d: "M 77.54 360.15 s 1.6 -4.86 1.34 -7.12 c -0.23 -1.94 -1.11 -4.33 -2.82 -5.37 a 3.46 3.46 0 0 0 -4.77 1.06 a 2.58 2.58 0 0 0 -0.18 0.32 c -1.22 2.66 1.46 7.18 3.39 8.93 C 74.66 358.13 77.53 360.21 77.54 360.15 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 80.4449 99.915)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(57,153,248)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-330.445, -349.915)",
    d: "M 307.76 350 c 0.12 28.66 22.89 51.83 22.89 51.83 s 22.6 -23.33 22.48 -52 S 330.2 298 330.2 298 S 307.63 321.29 307.76 350 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 80.47 99.8551)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0.22999999999998977,
    y1: 51.905,
    x2: -0.22999999999998977,
    y2: -51.905
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 74.0251 79.3251)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 6.385000000000019,
    y1: 5.525000000000006,
    x2: -6.385000000000019,
    y2: -5.525000000000006
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 88.5 90.565)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -7.829999999999984,
    y1: 11.435000000000002,
    x2: 7.829999999999984,
    y2: -11.435000000000002
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 71.1 103.555)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 9.419999999999987,
    y1: 8.33499999999998,
    x2: -9.419999999999987,
    y2: -8.33499999999998
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 90.0251 116.895)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -9.245000000000005,
    y1: 8.314999999999998,
    x2: 9.245000000000005,
    y2: -8.314999999999998
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 73.54 130.99)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 7.289999999999992,
    y1: 5.719999999999999,
    x2: -7.289999999999992,
    y2: -5.719999999999999
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 52.044 135.475)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(57,153,248)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-302.044, -385.475)",
    d: "M 292.22 394.23 c 11.06 12.38 29.87 13.66 29.87 13.66 s 0.83 -18.81 -10.26 -31.22 S 282 363.06 282 363.06 S 281.13 381.87 292.22 394.23 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 52.0301 135.455)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 20.07000000000002,
    y1: 22.435000000000002,
    x2: -20.07000000000002,
    y2: -22.435000000000002
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 41.3351 129.025)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 4.885000000000019,
    y1: -0.0549999999999784,
    x2: -4.885000000000019,
    y2: 0.0549999999999784
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 51.945 128.33)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 1.0049999999999955,
    y1: 7.969999999999999,
    x2: -1.0049999999999955,
    y2: -7.969999999999999
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 49.39 140.6601)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 7.289999999999992,
    y1: -0.010000000000019327,
    x2: -7.289999999999992,
    y2: 0.010000000000019327
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 62.735 139.165)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -0.8149999999999977,
    y1: 7.164999999999992,
    x2: 0.8149999999999977,
    y2: -7.164999999999992
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 61.0051 151.625)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 5.365000000000009,
    y1: -0.32499999999998863,
    x2: -5.365000000000009,
    y2: 0.32499999999998863
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 109.49 135.2)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(57,153,248)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-359.49, -385.2)",
    d: "M 350 376.07 c -11.53 12 -11.38 30.82 -11.38 30.82 s 18.8 -0.57 30.35 -12.56 s 11.39 -30.82 11.39 -30.82 S 361.53 364.1 350 376.07 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 109.49 135.2)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -20.870000000000005,
    y1: 21.689999999999998,
    x2: 20.870000000000005,
    y2: -21.689999999999998
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 115.1 124.065)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0.4199999999999875,
    y1: 4.875,
    x2: -0.4199999999999875,
    y2: -4.875
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 116.585 134.58)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -7.875,
    y1: 1.5999999999999943,
    x2: 7.875,
    y2: -1.5999999999999943
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 104.095 132.955)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0.5549999999999784,
    y1: 7.275000000000006,
    x2: -0.5549999999999784,
    y2: -7.275000000000006
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 106.58 146.1551)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -7.199999999999989,
    y1: -0.2750000000000057,
    x2: 7.199999999999989,
    y2: 0.2750000000000057
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 94.035 145.3551)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0.7249999999999943,
    y1: 5.325000000000017,
    x2: -0.7249999999999943,
    y2: -5.325000000000017
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 80.4449 99.915)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.4
    },
    transform: " translate(-330.445, -349.915)",
    d: "M 307.76 350 c 0.12 28.66 22.89 51.83 22.89 51.83 s 22.6 -23.33 22.48 -52 S 330.2 298 330.2 298 S 307.63 321.29 307.76 350 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 80.47 99.855)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 0.22999999999998977,
    y1: 51.905,
    x2: -0.22999999999998977,
    y2: -51.905
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 74.025 79.325)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 6.385000000000019,
    y1: 5.525000000000006,
    x2: -6.385000000000019,
    y2: -5.525000000000006
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 88.5 90.565)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: -7.829999999999984,
    y1: 11.435000000000002,
    x2: 7.829999999999984,
    y2: -11.435000000000002
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 71.1 103.555)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 9.419999999999987,
    y1: 8.33499999999998,
    x2: -9.419999999999987,
    y2: -8.33499999999998
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 90.025 116.895)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: -9.245000000000005,
    y1: 8.314999999999998,
    x2: 9.245000000000005,
    y2: -8.314999999999998
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 73.54 130.99)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 7.289999999999992,
    y1: 5.719999999999999,
    x2: -7.289999999999992,
    y2: -5.719999999999999
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 52.044 135.475)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.4
    },
    transform: " translate(-302.044, -385.475)",
    d: "M 292.22 394.23 c 11.06 12.38 29.87 13.66 29.87 13.66 s 0.83 -18.81 -10.26 -31.22 S 282 363.06 282 363.06 S 281.13 381.87 292.22 394.23 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 52.03 135.455)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 20.07000000000002,
    y1: 22.435000000000002,
    x2: -20.07000000000002,
    y2: -22.435000000000002
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 41.335 129.025)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 4.885000000000019,
    y1: -0.0549999999999784,
    x2: -4.885000000000019,
    y2: 0.0549999999999784
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 51.945 128.33)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 1.0049999999999955,
    y1: 7.969999999999999,
    x2: -1.0049999999999955,
    y2: -7.969999999999999
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 49.39 140.66)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 7.289999999999992,
    y1: -0.010000000000019327,
    x2: -7.289999999999992,
    y2: 0.010000000000019327
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 62.735 139.165)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: -0.8149999999999977,
    y1: 7.164999999999992,
    x2: 0.8149999999999977,
    y2: -7.164999999999992
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 61.005 151.625)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 5.365000000000009,
    y1: -0.32499999999998863,
    x2: -5.365000000000009,
    y2: 0.32499999999998863
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 109.49 135.2)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.4
    },
    transform: " translate(-359.49, -385.2)",
    d: "M 350 376.07 c -11.53 12 -11.38 30.82 -11.38 30.82 s 18.8 -0.57 30.35 -12.56 s 11.39 -30.82 11.39 -30.82 S 361.53 364.1 350 376.07 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 109.49 135.2)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: -20.870000000000005,
    y1: 21.689999999999998,
    x2: 20.870000000000005,
    y2: -21.689999999999998
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 115.1 124.065)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 0.4199999999999875,
    y1: 4.875,
    x2: -0.4199999999999875,
    y2: -4.875
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 116.585 134.58)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: -7.875,
    y1: 1.5999999999999943,
    x2: 7.875,
    y2: -1.5999999999999943
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 104.095 132.955)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 0.5549999999999784,
    y1: 7.275000000000006,
    x2: -0.5549999999999784,
    y2: -7.275000000000006
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 106.58 146.155)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: -7.199999999999989,
    y1: -0.2750000000000057,
    x2: 7.199999999999989,
    y2: 0.2750000000000057
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 94.035 145.355)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 0.7249999999999943,
    y1: 5.325000000000017,
    x2: -0.7249999999999943,
    y2: -5.325000000000017
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 47.4749 -149.145)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(57,153,248)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-297.4749, -100.855)",
    d: "M 278.49 100.94 c 0.1 23.94 19.16 43.28 19.16 43.28 s 18.89 -19.49 18.81 -43.44 S 297.3 57.49 297.3 57.49 S 278.38 77 278.49 100.94 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 47.465 -149.1449)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0.18500000000000227,
    y1: 43.364999999999995,
    x2: -0.18500000000000227,
    y2: -43.364999999999995
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 42.0751 -166.295)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 5.335000000000008,
    y1: 4.614999999999995,
    x2: -5.335000000000008,
    y2: -4.614999999999995
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 54.175 -156.9099)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -6.534999999999997,
    y1: 9.549999999999997,
    x2: 6.534999999999997,
    y2: -9.549999999999997
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 39.6401 -146.0549)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 7.8700000000000045,
    y1: 6.964999999999996,
    x2: -7.8700000000000045,
    y2: -6.964999999999996
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 55.445 -134.9099)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -7.724999999999994,
    y1: 6.950000000000003,
    x2: 7.724999999999994,
    y2: -6.950000000000003
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 41.6701 -123.13)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 6.090000000000003,
    y1: 4.780000000000001,
    x2: -6.090000000000003,
    y2: -4.780000000000001
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 23.72 -119.4)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(57,153,248)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-273.72, -130.6)",
    d: "M 265.5 137.93 c 9.26 10.35 25 11.41 25 11.41 s 0.7 -15.73 -8.56 -26.07 s -25 -11.41 -25 -11.41 S 256.24 127.58 265.5 137.93 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 23.7 -119.3999)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 16.75999999999999,
    y1: 18.740000000000002,
    x2: -16.75999999999999,
    y2: -18.740000000000002
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 14.7701 -124.77)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 4.090000000000003,
    y1: -0.04999999999999716,
    x2: -4.090000000000003,
    y2: 0.04999999999999716
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 23.6201 -125.3499)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0.8400000000000034,
    y1: 6.660000000000004,
    x2: -0.8400000000000034,
    y2: -6.660000000000004
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 21.495 -115.0499)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 6.094999999999999,
    y1: -0.010000000000005116,
    x2: -6.094999999999999,
    y2: 0.010000000000005116
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 32.6451 -116.3049)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -0.6850000000000023,
    y1: 5.9850000000000065,
    x2: 0.6850000000000023,
    y2: -5.9850000000000065
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 31.2 -105.8899)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 4.47999999999999,
    y1: -0.269999999999996,
    x2: -4.47999999999999,
    y2: 0.269999999999996
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 71.71 -119.615)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(57,153,248)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-321.71, -130.385)",
    d: "M 313.78 122.76 c -9.62 10 -9.51 25.75 -9.51 25.75 S 320 148 329.63 138 s 9.52 -25.74 9.52 -25.74 S 323.42 112.76 313.78 122.76 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 71.71 -119.6099)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -17.439999999999998,
    y1: 18.119999999999997,
    x2: 17.439999999999998,
    y2: -18.119999999999997
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 76.395 -128.9249)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0.35499999999998977,
    y1: 4.075000000000003,
    x2: -0.35499999999998977,
    y2: -4.075000000000003
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 77.635 -120.1299)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -6.574999999999989,
    y1: 1.3400000000000034,
    x2: 6.574999999999989,
    y2: -1.3400000000000034
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 67.195 -121.485)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0.4650000000000034,
    y1: 6.075000000000003,
    x2: -0.4650000000000034,
    y2: -6.075000000000003
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 69.2801 -110.4599)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -6.02000000000001,
    y1: -0.23000000000000398,
    x2: 6.02000000000001,
    y2: 0.23000000000000398
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 58.79 -111.125)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0.6099999999999852,
    y1: 4.444999999999993,
    x2: -0.6099999999999852,
    y2: -4.444999999999993
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 47.4749 -149.145)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.4
    },
    transform: " translate(-297.4749, -100.855)",
    d: "M 278.49 100.94 c 0.1 23.94 19.16 43.28 19.16 43.28 s 18.89 -19.49 18.81 -43.44 S 297.3 57.49 297.3 57.49 S 278.38 77 278.49 100.94 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 47.465 -149.145)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 0.18500000000000227,
    y1: 43.364999999999995,
    x2: -0.18500000000000227,
    y2: -43.364999999999995
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 42.075 -166.295)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 5.335000000000008,
    y1: 4.614999999999995,
    x2: -5.335000000000008,
    y2: -4.614999999999995
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 54.175 -156.91)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: -6.534999999999997,
    y1: 9.549999999999997,
    x2: 6.534999999999997,
    y2: -9.549999999999997
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 39.64 -146.055)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 7.8700000000000045,
    y1: 6.964999999999996,
    x2: -7.8700000000000045,
    y2: -6.964999999999996
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 55.445 -134.91)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: -7.724999999999994,
    y1: 6.950000000000003,
    x2: 7.724999999999994,
    y2: -6.950000000000003
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 41.67 -123.13)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 6.090000000000003,
    y1: 4.780000000000001,
    x2: -6.090000000000003,
    y2: -4.780000000000001
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 23.72 -119.4)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.4
    },
    transform: " translate(-273.72, -130.6)",
    d: "M 265.5 137.93 c 9.26 10.35 25 11.41 25 11.41 s 0.7 -15.73 -8.56 -26.07 s -25 -11.41 -25 -11.41 S 256.24 127.58 265.5 137.93 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 23.7 -119.4)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 16.75999999999999,
    y1: 18.740000000000002,
    x2: -16.75999999999999,
    y2: -18.740000000000002
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 14.77 -124.77)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 4.090000000000003,
    y1: -0.04999999999999716,
    x2: -4.090000000000003,
    y2: 0.04999999999999716
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 23.62 -125.35)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 0.8400000000000034,
    y1: 6.660000000000004,
    x2: -0.8400000000000034,
    y2: -6.660000000000004
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 21.495 -115.05)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 6.094999999999999,
    y1: -0.010000000000005116,
    x2: -6.094999999999999,
    y2: 0.010000000000005116
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 32.645 -116.305)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: -0.6850000000000023,
    y1: 5.9850000000000065,
    x2: 0.6850000000000023,
    y2: -5.9850000000000065
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 31.2 -105.89)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 4.47999999999999,
    y1: -0.269999999999996,
    x2: -4.47999999999999,
    y2: 0.269999999999996
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 71.71 -119.615)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.4
    },
    transform: " translate(-321.71, -130.385)",
    d: "M 313.78 122.76 c -9.62 10 -9.51 25.75 -9.51 25.75 S 320 148 329.63 138 s 9.52 -25.74 9.52 -25.74 S 323.42 112.76 313.78 122.76 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 71.71 -119.61)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: -17.439999999999998,
    y1: 18.119999999999997,
    x2: 17.439999999999998,
    y2: -18.119999999999997
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 76.395 -128.925)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 0.35499999999998977,
    y1: 4.075000000000003,
    x2: -0.35499999999998977,
    y2: -4.075000000000003
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 77.635 -120.13)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: -6.574999999999989,
    y1: 1.3400000000000034,
    x2: 6.574999999999989,
    y2: -1.3400000000000034
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 67.195 -121.485)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 0.4650000000000034,
    y1: 6.075000000000003,
    x2: -0.4650000000000034,
    y2: -6.075000000000003
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 69.28 -110.46)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: -6.02000000000001,
    y1: -0.23000000000000398,
    x2: 6.02000000000001,
    y2: 0.23000000000000398
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 58.79 -111.125)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 0.6099999999999852,
    y1: 4.444999999999993,
    x2: -0.6099999999999852,
    y2: -4.444999999999993
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -91.1549 120.115)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(57,153,248)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-158.8451, -370.115)",
    d: "M 144.07 370.18 c 0.08 18.66 14.92 33.71 14.92 33.71 s 14.72 -15.18 14.63 -33.84 s -14.93 -33.71 -14.93 -33.71 S 144 351.53 144.07 370.18 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -91.1599 120.1151)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0.15000000000000568,
    y1: 33.775000000000006,
    x2: -0.15000000000000568,
    y2: -33.775000000000006
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -95.3499 106.7601)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 4.150000000000006,
    y1: 3.5900000000000034,
    x2: -4.150000000000006,
    y2: -3.5900000000000034
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -85.93 114.07)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -5.090000000000003,
    y1: 7.439999999999998,
    x2: 5.090000000000003,
    y2: -7.439999999999998
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -97.255 122.53)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 6.134999999999991,
    y1: 5.4199999999999875,
    x2: -6.134999999999991,
    y2: -5.4199999999999875
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -84.935 131.21)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -6.015000000000001,
    y1: 5.409999999999997,
    x2: 6.015000000000001,
    y2: -5.409999999999997
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -95.6649 140.38)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 4.7450000000000045,
    y1: 3.719999999999999,
    x2: -4.7450000000000045,
    y2: -3.719999999999999
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -109.6114 143.27)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(57,153,248)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-140.3885, -393.27)",
    d: "M 134 399 c 7.2 8.06 19.43 8.85 19.43 8.85 s 0.55 -12.25 -6.63 -20.31 s -19.45 -8.85 -19.45 -8.85 S 126.74 390.94 134 399 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -109.665 143.29)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 13.054999999999993,
    y1: 14.599999999999994,
    x2: -13.054999999999993,
    y2: -14.599999999999994
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -116.6149 139.1101)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 3.1850000000000023,
    y1: -0.03999999999999204,
    x2: -3.1850000000000023,
    y2: 0.03999999999999204
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -109.72 138.65)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0.6599999999999966,
    y1: 5.189999999999998,
    x2: -0.6599999999999966,
    y2: -5.189999999999998
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -111.3749 146.675)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 4.7450000000000045,
    y1: -0.0049999999999954525,
    x2: -4.7450000000000045,
    y2: 0.0049999999999954525
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -102.6949 145.7001)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -0.5250000000000057,
    y1: 4.659999999999997,
    x2: 0.5250000000000057,
    y2: -4.659999999999997
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -103.82 153.82)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 3.489999999999995,
    y1: -0.20999999999997954,
    x2: -3.489999999999995,
    y2: 0.20999999999997954
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -72.2948 143.115)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(57,153,248)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-177.7051, -393.115)",
    d: "M 171.56 387.18 c -7.5 7.8 -7.41 20.05 -7.41 20.05 s 12.25 -0.37 19.76 -8.16 S 191.26 379 191.26 379 S 179.09 379.39 171.56 387.18 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -72.27 143.1201)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -13.579999999999998,
    y1: 14.110000000000014,
    x2: 13.579999999999998,
    y2: -14.110000000000014
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -68.615 135.8751)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0.2749999999999915,
    y1: 3.1750000000000114,
    x2: -0.2749999999999915,
    y2: -3.1750000000000114
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -67.6549 142.72)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -5.125,
    y1: 1.039999999999992,
    x2: 5.125,
    y2: -1.039999999999992
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -75.7799 141.66)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0.35999999999999943,
    y1: 4.72999999999999,
    x2: -0.35999999999999943,
    y2: -4.72999999999999
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -74.16 150.2501)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.689999999999998,
    y1: -0.18000000000000682,
    x2: 4.689999999999998,
    y2: 0.18000000000000682
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -82.3299 149.7351)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.9939,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0.46999999999999886,
    y1: 3.4650000000000034,
    x2: -0.46999999999999886,
    y2: -3.4650000000000034
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -91.1549 120.115)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.4
    },
    transform: " translate(-158.8451, -370.115)",
    d: "M 144.07 370.18 c 0.08 18.66 14.92 33.71 14.92 33.71 s 14.72 -15.18 14.63 -33.84 s -14.93 -33.71 -14.93 -33.71 S 144 351.53 144.07 370.18 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -91.16 120.115)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 0.15000000000000568,
    y1: 33.775000000000006,
    x2: -0.15000000000000568,
    y2: -33.775000000000006
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -95.35 106.76)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 4.150000000000006,
    y1: 3.5900000000000034,
    x2: -4.150000000000006,
    y2: -3.5900000000000034
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -85.93 114.07)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: -5.090000000000003,
    y1: 7.439999999999998,
    x2: 5.090000000000003,
    y2: -7.439999999999998
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -97.255 122.53)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 6.134999999999991,
    y1: 5.4199999999999875,
    x2: -6.134999999999991,
    y2: -5.4199999999999875
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -84.935 131.21)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: -6.015000000000001,
    y1: 5.409999999999997,
    x2: 6.015000000000001,
    y2: -5.409999999999997
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -95.665 140.38)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 4.7450000000000045,
    y1: 3.719999999999999,
    x2: -4.7450000000000045,
    y2: -3.719999999999999
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -109.6114 143.27)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.4
    },
    transform: " translate(-140.3885, -393.27)",
    d: "M 134 399 c 7.2 8.06 19.43 8.85 19.43 8.85 s 0.55 -12.25 -6.63 -20.31 s -19.45 -8.85 -19.45 -8.85 S 126.74 390.94 134 399 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -109.665 143.29)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 13.054999999999993,
    y1: 14.599999999999994,
    x2: -13.054999999999993,
    y2: -14.599999999999994
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -116.615 139.11)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 3.1850000000000023,
    y1: -0.03999999999999204,
    x2: -3.1850000000000023,
    y2: 0.03999999999999204
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -109.72 138.65)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 0.6599999999999966,
    y1: 5.189999999999998,
    x2: -0.6599999999999966,
    y2: -5.189999999999998
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -111.375 146.675)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 4.7450000000000045,
    y1: -0.0049999999999954525,
    x2: -4.7450000000000045,
    y2: 0.0049999999999954525
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -102.695 145.7)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: -0.5250000000000057,
    y1: 4.659999999999997,
    x2: 0.5250000000000057,
    y2: -4.659999999999997
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -103.82 153.82)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 3.489999999999995,
    y1: -0.20999999999997954,
    x2: -3.489999999999995,
    y2: 0.20999999999997954
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -72.2948 143.115)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.4
    },
    transform: " translate(-177.7051, -393.115)",
    d: "M 171.56 387.18 c -7.5 7.8 -7.41 20.05 -7.41 20.05 s 12.25 -0.37 19.76 -8.16 S 191.26 379 191.26 379 S 179.09 379.39 171.56 387.18 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -72.27 143.12)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: -13.579999999999998,
    y1: 14.110000000000014,
    x2: 13.579999999999998,
    y2: -14.110000000000014
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -68.615 135.875)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 0.2749999999999915,
    y1: 3.1750000000000114,
    x2: -0.2749999999999915,
    y2: -3.1750000000000114
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -67.655 142.72)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: -5.125,
    y1: 1.039999999999992,
    x2: 5.125,
    y2: -1.039999999999992
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -75.78 141.66)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 0.35999999999999943,
    y1: 4.72999999999999,
    x2: -0.35999999999999943,
    y2: -4.72999999999999
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -74.16 150.25)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: -4.689999999999998,
    y1: -0.18000000000000682,
    x2: 4.689999999999998,
    y2: 0.18000000000000682
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -82.33 149.735)",
    id: "freepik--plants--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 0.4
    },
    x1: 0.46999999999999886,
    y1: 3.4650000000000034,
    x2: -0.46999999999999886,
    y2: -3.4650000000000034
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -107.95 -138.875)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "-9.59,-22.935 -22.53,-11.635 -10.73,25.895 16.48,25.395 22.53,-20.645 3.2,-25.895 -9.59,-22.935 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -105.515 -136.6403)",
    id: "freepik--character-2--inject-99",
    clipPath: "url(#CLIPPATH_11)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_11"
  }, /*#__PURE__*/React.createElement("polygon", {
    transform: "matrix(1 0 0 1 -2.435 -2.2347)",
    id: "freepik--clip-path--inject-99",
    points: "-9.59,-22.935 -22.53,-11.635 -10.73,25.895 16.48,25.395 22.53,-20.645 3.2,-25.895 -9.59,-22.935 "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(57,153,248)",
      fillRule: "nonzero",
      opacity: 0.5
    },
    transform: " translate(-144.485, -113.3597)",
    d: "M 155 91.47 c -2.3 -0.51 -5.88 -1.79 -5.88 -1.79 s -14.58 -0.25 -16.9 9.21 l -0.76 3.84 l 3.84 -1 l -4.87 7.43 c -0.52 0.78 -1 -6.4 -2.05 -5.63 S 125.1 114 125.1 114 l 1.48 7.94 l 4.74 15.1 l 27.2 -0.5 l 5.35 -40.66 C 162.43 95 157 91.91 155 91.47 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -107.9501 -138.875)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "-9.59,-22.935 -22.53,-11.635 -10.73,25.895 16.48,25.395 22.53,-20.645 3.2,-25.895 -9.59,-22.935 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -109.0901 -135.675)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "-5.98,-18.275 -1.57,-13.025 -2.7,18.435 1.55,24.165 5.98,15.645 -0.25,-13.025 3.36,-19.095 1.89,-24.165 -5.98,-18.275 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -109.6322 -158.7481)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-140.3679, -91.2519)",
    d: "M 131.32 87 a 24.59 24.59 0 0 0 -1.1 6.71 a 30 30 0 0 0 1.47 7.74 s 3.32 -4.27 5.53 -5.08 s 6.72 -1.31 8.2 -0.66 s 5.08 3 5.08 3 a 26.68 26.68 0 0 0 -1.64 -10.17 c -2 -4.91 -2.79 -6.72 -4.11 -7.2 S 133.61 80.15 131.32 87 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -132.535 -135.501)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-117.465, -114.499)",
    d: "M 119.52 99.49 L 109.4 125.38 s 7.86 4.59 8 4.09 s 8.13 -11 8.13 -11 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -129.42 -134.575)",
    id: "freepik--character-2--inject-99",
    clipPath: "url(#CLIPPATH_12)"
  }, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_12"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 1 -3.115 -0.926) translate(-117.465, -114.499)",
    id: "freepik--clip-path-2--inject-99",
    d: "M 119.52 99.49 L 109.4 125.38 s 7.86 4.59 8 4.09 s 8.13 -11 8.13 -11 Z",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(57,153,248)",
      fillRule: "nonzero",
      opacity: 0.5
    },
    transform: " translate(-120.58, -115.425)",
    d: "M 121.77 113.48 s -6.56 -2.54 -4.86 -1 a 64.9 64.9 0 0 1 4.86 5.36 l -6.14 3.08 l 4.31 5 c 2.38 -3.21 5.59 -7.42 5.59 -7.42 l -4.28 -13.57 l -0.25 0.1 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -132.5351 -135.501)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-117.465, -114.499)",
    d: "M 119.52 99.49 L 109.4 125.38 s 7.86 4.59 8 4.09 s 8.13 -11 8.13 -11 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -73.97 -146.71)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "-11.45,-12.81 13.41,7.1 3.73,12.81 -13.41,2.92 -11.45,-12.81 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -78.11 -144.005)",
    id: "freepik--character-2--inject-99",
    clipPath: "url(#CLIPPATH_13)"
  }, _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_13"
  }, /*#__PURE__*/React.createElement("polygon", {
    transform: "matrix(1 0 0 1 4.14 -2.705)",
    id: "freepik--clip-path-3--inject-99",
    points: "-11.45,-12.81 13.41,7.1 3.73,12.81 -13.41,2.92 -11.45,-12.81 "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(57,153,248)",
      fillRule: "nonzero",
      opacity: 0.5
    },
    transform: " translate(-171.89, -105.995)",
    d: "M 181.13 113.22 l -8.44 -6.14 s 3.84 -0.77 4.6 -1.79 s -9 -0.76 -9 -0.76 l 3.07 -4.1 l -5.88 2 V 99.91 l -1.62 -4 l -1.28 10.28 l 17.14 9.89 l 1.48 -0.88 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -73.9701 -146.71)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "-11.45,-12.81 13.41,7.1 3.73,12.81 -13.41,2.92 -11.45,-12.81 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -110.16 -162.4478)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-139.84, -87.5522)",
    d: "M 131.32 87 s 2.13 5.74 4.58 8 s 4.6 1.8 6.23 -0.33 s 3.44 -9.18 3.94 -9.51 s 2.29 -2 2.29 -3.6 s -2.12 -0.82 -2.46 -0.16 l -0.33 0.65 l -1.63 -3.44 a 33.32 33.32 0 0 1 -2.79 5.53 c -1.31 1.81 -1.64 3.12 -2.94 2.14 s -2.31 -2.46 -3.32 -0.82 S 131.32 87 131.32 87 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -110.215 -165.6368)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(57,153,248)",
      fillRule: "nonzero",
      opacity: 0.5
    },
    transform: " translate(-139.785, -84.3632)",
    d: "M 145.9 81.47 l -0.33 0.65 l -1.63 -3.44 a 33.32 33.32 0 0 1 -2.79 5.53 c -1.31 1.81 -1.64 3.12 -2.94 2.14 s -2.31 -2.46 -3.32 -0.82 S 131.28 87 131.28 87 s 0.5 1.35 1.29 3 c 4.23 0.22 11.07 -0.18 12.64 -4.8 v 1.94 A 6.76 6.76 0 0 1 146 85.2 c 0.48 -0.32 2.29 -2 2.29 -3.61 S 146.24 80.81 145.9 81.47 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -113.8751 -158.817)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.5531,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-136.125, -91.183)",
    d: "M 133.19 88.92 s 2.29 1 3.11 0.35 c 0 0 0.17 4.56 1.31 4.15 l 1.45 -1",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -108.7751 -161.1149)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.5531,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-141.225, -88.8851)",
    d: "M 139.69 89.06 s 1.2 1 3.07 -0.65",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -109.1701 -162.9163)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.5531,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-140.83, -87.0837)",
    d: "M 138.86 88.23 s 0 -2.49 3.94 -2.28",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -115.0151 -162.08)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.5531,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-134.985, -87.92)",
    d: "M 136.3 89.27 a 3.74 3.74 0 0 0 -2.63 -2.7",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -111.35 -156.0348)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.5531,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-138.65, -93.9652)",
    d: "M 136.78 94.24 a 3.21 3.21 0 0 0 3.74 -0.83",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -114.7379 -175.3464)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-135.2621, -74.6536)",
    d: "M 147.54 81.63 s 4.53 -4.76 2.05 -10.23 c -1.63 -3.59 -1.88 -3.45 -5.82 -7.63 s -12 -1.9 -14.7 1 s -0.83 8.08 -1.87 8.7 s -7.26 2.49 -7 5 s 7 3.73 6.22 4.56 s -6.22 0.62 -3.73 2.7 s 9.67 3.13 15.57 0.67 s 5.53 -6.07 5.53 -6.07 S 144.47 84.39 147.54 81.63 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -112.0468 -169.2518)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.5531,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-137.9533, -80.7482)",
    d: "M 133.05 85.93 s 3.5 0.62 7.6 -2.67 s 1.23 -7.74 1.23 -7.74",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -104.9341 -173.255)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.5531,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-145.066, -76.745)",
    d: "M 144.54 72.18 s 2.22 7.17 0.21 9.13",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -118.6551 -167.9584)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.5531,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-131.345, -82.0416)",
    d: "M 126.37 83 s 6.64 1.48 9.95 -2.21",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -135.5486 -124.8032)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-114.4514, -125.1968)",
    d: "M 111.32 128.84 s -5 -1.1 -4.15 -3.87 s 0 -5.81 6.09 -5.26 s 8.57 1.94 8.57 4.71 s -0.83 7.46 -4.15 6.08 A 24.05 24.05 0 0 0 111.32 128.84 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -81.305 -146.0651)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("polyline", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.5531,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "0.885,-2.275 -6.075,2.275 6.075,-0.545 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -127.9951 -135.775)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.5531,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 2.7550000000000026,
    y1: 2.634999999999998,
    x2: -2.7550000000000026,
    y2: -2.634999999999998
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -129.55 -135.065)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.5531,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 1.8400000000000034,
    y1: 0.9750000000000014,
    x2: -1.8400000000000034,
    y2: -0.9750000000000014
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -95.3201 -139.705)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("polyline", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.5531,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "3.24,-1.075 -3.24,-0.865 -3.24,1.075 2.81,1.075 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -135.709 -124.5707)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(57,153,248)",
      fillRule: "nonzero",
      opacity: 0.5
    },
    transform: " translate(-114.2909, -125.4293)",
    d: "M 110.25 126.78 s -3.06 -1.57 -1.79 -2.56 a 9.59 9.59 0 0 1 6.64 -1.28 a 17.64 17.64 0 0 1 3.83 1.54 s -3.31 -2.56 -1.28 -2.56 s 3.32 2.56 2.56 5.12 s -3.84 1.79 -3.84 1.79 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -20.58 134.395)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 1.1063,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-229.42, -384.395)",
    d: "M 258.29 387.49 V 351.61 H 200.55 v 35.88 a 23.24 23.24 0 0 1 -6.75 16.41 l -13.16 13.28 H 278.2 L 265.05 403.9 A 23.2 23.2 0 0 1 258.29 387.49 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -20.58 123.62)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(57,153,248)",
      fillRule: "nonzero",
      opacity: 0.44
    },
    transform: " translate(-229.42, -373.62)",
    d: "M 200.55 351.61 v 35.88 a 23.1 23.1 0 0 1 -1.49 8.14 h 60.72 a 23.32 23.32 0 0 1 -1.49 -8.14 V 351.61 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -20.58 116.5401)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 1.1063,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -28.87,
    y: -13.31,
    rx: 0,
    ry: 0,
    width: 57.74,
    height: 26.62
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -20.5849 168.1301)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 1.1063,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -48.775,
    y: -0.95,
    rx: 0,
    ry: 0,
    width: 97.55,
    height: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -20.5449 0.6401)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 1.1063,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-229.455, -250.64)",
    d: "M 89.39 132 H 369.46 A 13.53 13.53 0 0 1 383 145.56 h 0 V 354.64 a 14.69 14.69 0 0 1 -14.73 14.64 H 90.59 A 14.68 14.68 0 0 1 75.91 354.6 V 145.51 A 13.53 13.53 0 0 1 89.39 132 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -20.57 105.5501)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 1.1063,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-229.43, -355.55)",
    d: "M 75.86 341.82 H 383 V 354.6 a 14.68 14.68 0 0 1 -14.68 14.68 H 90.59 A 14.68 14.68 0 0 1 75.91 354.6 V 341.82 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 7.7849 -11.495)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -137.295,
    y: -91.525,
    rx: 0,
    ry: 0,
    width: 274.59,
    height: 183.05
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 7.785 -73.36)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(57,153,248)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -137.295,
    y: -29.66,
    rx: 0,
    ry: 0,
    width: 274.59,
    height: 59.32
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -9.505 19.32)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(57,153,248)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-240.495, -269.32)",
    d: "M 148.47 317.7 H 137.41 V 221 h 11.06 Z m 21.68 -96.76 h -11 V 317.7 h 11.06 Z m 21.69 0 H 180.77 V 317.7 h 11.07 Z m 21.67 0 H 202.45 V 317.7 h 11.06 Z m 21.68 0 H 224.13 V 317.7 h 11.06 Z m 21.67 0 H 245.8 V 317.7 h 11.06 Z m 21.69 0 H 267.48 V 317.7 h 11.07 Z m 21.68 0 H 289.17 V 317.7 h 11.06 Z m 21.67 0 H 310.84 V 317.7 H 321.9 Z m 21.68 0 H 332.52 V 317.7 h 11.06 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -9.505 19.32)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.4
    },
    transform: " translate(-240.495, -269.32)",
    d: "M 148.47 317.7 H 137.41 V 221 h 11.06 Z m 21.68 -96.76 h -11 V 317.7 h 11.06 Z m 21.69 0 H 180.77 V 317.7 h 11.07 Z m 21.67 0 H 202.45 V 317.7 h 11.06 Z m 21.68 0 H 224.13 V 317.7 h 11.06 Z m 21.67 0 H 245.8 V 317.7 h 11.06 Z m 21.69 0 H 267.48 V 317.7 h 11.07 Z m 21.68 0 H 289.17 V 317.7 h 11.06 Z m 21.67 0 H 310.84 V 317.7 H 321.9 Z m 21.68 0 H 332.52 V 317.7 h 11.06 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -80.22 -83.235)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-169.78, -166.765)",
    d: "M 206.14 169.19 H 133.43 a 2.43 2.43 0 0 1 -2.43 -2.43 h 0 a 2.43 2.43 0 0 1 2.43 -2.42 h 72.71 a 2.42 2.42 0 0 1 2.42 2.42 h 0 a 2.42 2.42 0 0 1 -2.42 2.43 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -92.4299 -83.2349)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 1.1063,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-157.57, -166.765)",
    d: "M 184.14 169.19 H 133.43 a 2.43 2.43 0 0 1 -2.43 -2.43 h 0 a 2.43 2.43 0 0 1 2.43 -2.42 h 50.71 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -80.22 -73.72)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-169.78, -176.28)",
    d: "M 206.14 178.7 H 133.43 a 2.42 2.42 0 0 1 -2.43 -2.42 h 0 a 2.42 2.42 0 0 1 2.43 -2.42 h 72.71 a 2.42 2.42 0 0 1 2.42 2.42 h 0 a 2.42 2.42 0 0 1 -2.42 2.42 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -87.7449 -73.72)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 1.1063,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-162.255, -176.28)",
    d: "M 193.47 178.7 h -60 a 2.42 2.42 0 0 1 -2.43 -2.42 h 0 a 2.42 2.42 0 0 1 2.43 -2.42 h 60 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -80.22 -64.155)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-169.78, -185.845)",
    d: "M 206.14 188.27 H 133.43 a 2.42 2.42 0 0 1 -2.43 -2.42 h 0 a 2.43 2.43 0 0 1 2.43 -2.43 h 72.71 a 2.42 2.42 0 0 1 2.42 2.43 h 0 a 2.42 2.42 0 0 1 -2.42 2.42 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -98.9149 -64.1549)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 1.1063,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-151.085, -185.845)",
    d: "M 171.17 188.27 H 133.43 a 2.42 2.42 0 0 1 -2.43 -2.42 h 0 a 2.43 2.43 0 0 1 2.43 -2.43 h 37.74 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -80.22 -54.7)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-169.78, -195.3)",
    d: "M 206.14 197.73 H 133.43 a 2.43 2.43 0 0 1 -2.43 -2.42 h 0 a 2.45 2.45 0 0 1 2.43 -2.44 h 72.71 a 2.44 2.44 0 0 1 2.42 2.44 h 0 a 2.42 2.42 0 0 1 -2.42 2.42 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -82.7399 -54.6999)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 1.1063,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-167.26, -195.3)",
    d: "M 203.52 197.73 H 133.43 a 2.43 2.43 0 0 1 -2.43 -2.42 h 0 a 2.45 2.45 0 0 1 2.43 -2.44 h 70.09 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -9.525 67.73)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -108.94500000000001,
    y1: 0,
    x2: 108.94500000000001,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -96.68 66.635)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0,
    y1: 1.0949999999999989,
    x2: 0,
    y2: -1.0949999999999989
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -74.8901 66.635)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0,
    y1: 1.0949999999999989,
    x2: 0,
    y2: -1.0949999999999989
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -53.1 66.635)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0,
    y1: 1.0949999999999989,
    x2: 0,
    y2: -1.0949999999999989
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -31.3101 66.635)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0,
    y1: 1.0949999999999989,
    x2: 0,
    y2: -1.0949999999999989
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -9.5201 66.635)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0,
    y1: 1.0949999999999989,
    x2: 0,
    y2: -1.0949999999999989
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 12.2699 66.635)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0,
    y1: 1.0949999999999989,
    x2: 0,
    y2: -1.0949999999999989
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 34.06 66.635)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0,
    y1: 1.0949999999999989,
    x2: 0,
    y2: -1.0949999999999989
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 55.8499 66.635)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0,
    y1: 1.0949999999999989,
    x2: 0,
    y2: -1.0949999999999989
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 77.6399 66.635)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0,
    y1: 1.0949999999999989,
    x2: 0,
    y2: -1.0949999999999989
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 99.42 66.635)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0,
    y1: 1.0949999999999989,
    x2: 0,
    y2: -1.0949999999999989
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -118.4701 19.505)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("polyline", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "0,48.225 0,39.585 0,-48.225 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -115.7451 59.09)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -2.7249999999999943,
    y1: 0,
    x2: 2.7249999999999943,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -115.7451 44.45)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -2.7249999999999943,
    y1: 0,
    x2: 2.7249999999999943,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -115.7451 29.81)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -2.7249999999999943,
    y1: 0,
    x2: 2.7249999999999943,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -115.7451 15.1899)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -2.7249999999999943,
    y1: 0,
    x2: 2.7249999999999943,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -115.7451 0.5499)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -2.7249999999999943,
    y1: 0,
    x2: 2.7249999999999943,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -115.7451 -14.08)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -2.7249999999999943,
    y1: 0,
    x2: 2.7249999999999943,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -115.7451 -28.72)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -2.7249999999999943,
    y1: 0,
    x2: 2.7249999999999943,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 121.1899 -69.1701)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -17.77,
    y: -18.3,
    rx: 0,
    ry: 0,
    width: 35.54,
    height: 36.6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 121.19 -84.3299)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 1.0079,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -17.77,
    y: -3.14,
    rx: 0,
    ry: 0,
    width: 35.54,
    height: 6.28
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 106.68 -65.675)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0,
    y1: -10.394999999999996,
    x2: 0,
    y2: 10.394999999999996
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 111.48 -65.675)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0,
    y1: -10.394999999999996,
    x2: 0,
    y2: 10.394999999999996
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 116.2699 -65.675)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0,
    y1: -10.394999999999996,
    x2: 0,
    y2: 10.394999999999996
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 121.07 -65.675)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0,
    y1: -10.394999999999996,
    x2: 0,
    y2: 10.394999999999996
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 125.88 -65.675)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0,
    y1: -10.394999999999996,
    x2: 0,
    y2: 10.394999999999996
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 130.6799 -65.675)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0,
    y1: -10.394999999999996,
    x2: 0,
    y2: 10.394999999999996
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 135.48 -65.675)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0,
    y1: -10.394999999999996,
    x2: 0,
    y2: 10.394999999999996
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 121 -73.35)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 14.160000000000025,
    y1: 0,
    x2: -14.160000000000025,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 121 -69.51)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 14.160000000000025,
    y1: 0,
    x2: -14.160000000000025,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 121 -65.6701)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 14.160000000000025,
    y1: 0,
    x2: -14.160000000000025,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 121 -61.83)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 14.160000000000025,
    y1: 0,
    x2: -14.160000000000025,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 121 -57.99)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 14.160000000000025,
    y1: 0,
    x2: -14.160000000000025,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -96.68 45.78)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 2.2125,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 10.89,
    y1: -21.950000000000017,
    x2: -10.89,
    y2: 21.950000000000017
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -74.8901 38.4599)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 2.2125,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 10.899999999999991,
    y1: 14.629999999999995,
    x2: -10.899999999999991,
    y2: -14.629999999999995
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -53.095 41.3849)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 2.2125,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 10.89500000000001,
    y1: -11.704999999999984,
    x2: -10.89500000000001,
    y2: 11.704999999999984
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -31.3101 4.8049)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 2.2125,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 10.89,
    y1: -24.875,
    x2: -10.89,
    y2: 24.875
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -9.5201 -12.7551)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 2.2125,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 10.899999999999991,
    y1: 7.314999999999998,
    x2: -10.899999999999991,
    y2: -7.314999999999998
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 12.27 20.1699)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 2.2125,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 10.890000000000015,
    y1: 25.609999999999985,
    x2: -10.890000000000015,
    y2: -25.609999999999985
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 34.0549 43.5849)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 2.2125,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 10.894999999999982,
    y1: -2.194999999999993,
    x2: -10.894999999999982,
    y2: 2.194999999999993
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 55.85 38.46)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 2.2125,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 10.900000000000006,
    y1: -2.930000000000007,
    x2: -10.900000000000006,
    y2: 2.930000000000007
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 77.6399 22.3599)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 2.2125,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 10.889999999999986,
    y1: -13.169999999999987,
    x2: -10.889999999999986,
    y2: 13.169999999999987
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -107.575 67.775)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-142.425, -317.775)",
    d: "M 142.43 315.49 h 0 a 2.28 2.28 0 0 1 2.28 2.28 h 0 a 2.29 2.29 0 0 1 -2.28 2.29 h 0 a 2.3 2.3 0 0 1 -2.29 -2.29 h 0 A 2.29 2.29 0 0 1 142.43 315.49 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -85.785 23.83)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-164.215, -273.83)",
    d: "M 164.21 271.55 h 0 a 2.29 2.29 0 0 1 2.29 2.28 h 0 a 2.29 2.29 0 0 1 -2.29 2.28 h 0 a 2.28 2.28 0 0 1 -2.28 -2.28 h 0 A 2.28 2.28 0 0 1 164.21 271.55 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -64 53.0949)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-186, -303.095)",
    d: "M 186 300.81 h 0 a 2.28 2.28 0 0 1 2.28 2.28 h 0 a 2.29 2.29 0 0 1 -2.28 2.29 h 0 a 2.29 2.29 0 0 1 -2.28 -2.29 h 0 A 2.28 2.28 0 0 1 186 300.81 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -42.15 29.68)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-207.85, -279.68)",
    d: "M 207.86 277.4 h 0 a 2.28 2.28 0 0 1 2.27 2.28 h 0 a 2.28 2.28 0 0 1 -2.27 2.28 h 0 a 2.29 2.29 0 0 1 -2.29 -2.28 h 0 A 2.29 2.29 0 0 1 207.86 277.4 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -20.415 -20.075)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-229.585, -229.925)",
    d: "M 229.58 227.64 h 0 a 2.29 2.29 0 0 1 2.29 2.29 h 0 a 2.29 2.29 0 0 1 -2.29 2.28 h 0 a 2.28 2.28 0 0 1 -2.28 -2.28 h 0 A 2.29 2.29 0 0 1 229.58 227.64 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 1.38 -5.4351)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-251.38, -244.565)",
    d: "M 251.38 242.28 h 0 a 2.29 2.29 0 0 1 2.28 2.28 h 0 a 2.29 2.29 0 0 1 -2.28 2.29 h 0 a 2.29 2.29 0 0 1 -2.28 -2.29 h 0 A 2.28 2.28 0 0 1 251.38 242.28 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 23.1349 45.78)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-273.135, -295.78)",
    d: "M 273.13 293.5 h 0 a 2.29 2.29 0 0 1 2.29 2.28 h 0 a 2.29 2.29 0 0 1 -2.29 2.28 h 0 a 2.28 2.28 0 0 1 -2.28 -2.28 h 0 A 2.28 2.28 0 0 1 273.13 293.5 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 45 41.3949)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-295, -291.395)",
    d: "M 295 289.11 h 0 a 2.28 2.28 0 0 1 2.28 2.28 h 0 a 2.29 2.29 0 0 1 -2.28 2.29 h 0 a 2.29 2.29 0 0 1 -2.28 -2.29 h 0 A 2.28 2.28 0 0 1 295 289.11 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 66.74 35.53)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-316.74, -285.53)",
    d: "M 316.75 283.25 h 0 a 2.28 2.28 0 0 1 2.27 2.28 h 0 a 2.28 2.28 0 0 1 -2.27 2.28 h 0 a 2.29 2.29 0 0 1 -2.29 -2.28 h 0 A 2.29 2.29 0 0 1 316.75 283.25 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 88.5349 9.19)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-338.535, -259.19)",
    d: "M 338.53 256.91 h 0 a 2.29 2.29 0 0 1 2.29 2.28 h 0 a 2.29 2.29 0 0 1 -2.29 2.28 h 0 a 2.28 2.28 0 0 1 -2.28 -2.28 h 0 A 2.28 2.28 0 0 1 338.53 256.91 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -85.58 10.66)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-164.42, -260.66)",
    d: "M 170.39 263.66 h -11.9 a 3 3 0 0 1 -3 -3 h 0 a 3 3 0 0 1 2.95 -3 h 11.91 a 3 3 0 0 1 3 3 v 0 h 0 a 3 3 0 0 1 -3 3 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -85.79 17.75)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0,
    y1: 3.8000000000000114,
    x2: 0,
    y2: -3.8000000000000114
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -20.42 -33.1596)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-229.58, -216.8404)",
    d: "M 235.51 219.84 H 223.58 a 3 3 0 0 1 -3 -3 h 0 a 3 3 0 0 1 3 -3 h 12 a 3 3 0 0 1 3 3 h 0 A 3 3 0 0 1 235.51 219.84 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -20.7 -26.0701)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0,
    y1: 3.799999999999997,
    x2: 0,
    y2: -3.799999999999997
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 88.2649 -4.34)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-338.265, -245.66)",
    d: "M 344.21 248.66 H 332.32 a 3 3 0 0 1 -3 -3 h 0 a 3 3 0 0 1 3 -3 h 11.89 a 3 3 0 0 1 3 2.9 v 0.07 h 0 a 3 3 0 0 1 -3 3 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 88.04 2.75)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 0,
    y1: 3.8000000000000114,
    x2: 0,
    y2: -3.8000000000000114
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -11.3101 -70.2801)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-238.69, -179.72)",
    d: "M 238.69 162.53 a 17.19 17.19 0 1 0 17.19 17.19 h 0 A 17.2 17.2 0 0 0 238.69 162.53 Z m 0 29.32 a 12.17 12.17 0 1 1 12.17 -12.16 a 12.16 12.16 0 0 1 -12.17 12.16 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -8.6971 -70.2773)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 1.0079,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-241.3028, -179.7227)",
    d: "M 238.69 162.53 a 17 17 0 0 0 -12.4 5.3 l 3.64 3.49 a 12 12 0 0 1 8.76 -3.75 a 12.17 12.17 0 1 1 0 24.34 h 0 v 5 a 17.19 17.19 0 0 0 0.87 -34.37 h -0.87 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -11.3051 -71.19)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -11.3051 -69.37)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -112.865 -91.02)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -112.865 -89.21)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -101.035 -91.02)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -101.035 -89.21)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -89.225 -91.02)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -89.225 -89.21)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -112.865 -37.8)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -112.865 -36.0001)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -101.035 -37.8)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -101.035 -36.0001)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -89.225 -37.8)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -89.225 -36.0001)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 110.525 -28.6501)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 122.355 -28.6501)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 134.165 -28.6501)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 110.525 -26.43)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 122.355 -26.43)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 134.165 -26.43)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 110.525 -24.19)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 122.355 -24.19)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 134.165 -24.19)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 110.525 -21.97)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 122.355 -21.97)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 134.165 -21.97)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 110.525 -19.7401)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 122.355 -19.7401)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 134.165 -19.7401)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 110.525 -17.5)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 122.355 -17.5)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 134.165 -17.5)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 110.525 -15.2801)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 122.355 -15.2801)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 134.165 -15.2801)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 110.525 -13.0401)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 122.355 -13.0401)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 134.165 -13.0401)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 110.525 -10.8201)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 122.355 -10.8201)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 134.165 -10.8201)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 110.525 -8.58)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 122.355 -8.58)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 134.165 -8.58)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 110.525 -6.35)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 122.355 -6.35)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 134.165 -6.35)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 110.525 -4.13)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 122.355 -4.13)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 134.165 -4.13)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 110.525 -1.8901)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 122.355 -1.8901)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 134.165 -1.8901)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 110.525 0.3299)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 122.355 0.3299)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 134.165 0.3299)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 110.525 2.5699)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 122.355 2.5699)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 134.165 2.5699)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 28.99 -70.28)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-278.99, -179.72)",
    d: "M 279 162.53 a 17.19 17.19 0 1 0 17.18 17.2 h 0 A 17.21 17.21 0 0 0 279 162.53 Z m 0 29.32 a 12.17 12.17 0 1 1 12.17 -12.16 A 12.16 12.16 0 0 1 279 191.85 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 31.11 -80.3224)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 1.0079,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-281.11, -169.6776)",
    d: "M 290.83 176.83 l 4.75 -1.78 a 17.17 17.17 0 0 0 -28.94 -7.22 l 3.64 3.49 a 12.13 12.13 0 0 1 20.55 5.51 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 28.7749 -71.19)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 28.7749 -69.37)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 71.0651 -70.2795)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-321.065, -179.7205)",
    d: "M 334.73 169.31 a 17.18 17.18 0 1 0 -3.26 24.08 A 17.17 17.17 0 0 0 334.73 169.31 Z M 311.4 187.08 a 12.17 12.17 0 1 1 17.06 2.28 l 0 0 A 12.18 12.18 0 0 1 311.4 187.08 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 80.3305 -73.6549)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 1.0079,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-330.3304, -176.345)",
    d: "M 330.49 187.34 l 4.3 2.71 A 17.19 17.19 0 0 0 323 162.64 l -0.58 5 a 12.17 12.17 0 0 1 8.06 19.69 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 70.825 -71.19)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 70.825 -69.37)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 121.953 49.9405)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 1.1063,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(57,153,248)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-371.953, -299.9405)",
    d: "M 385.62 289.53 a 17.18 17.18 0 1 0 -3.26 24.08 A 17.18 17.18 0 0 0 385.62 289.53 Z m -23.33 17.75 a 12.17 12.17 0 1 1 17.06 2.3 h 0 A 12.17 12.17 0 0 1 362.29 307.28 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 131.2266 46.56)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 1.0079,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-381.2266, -296.56)",
    d: "M 381.37 307.56 l 4.31 2.7 a 17.18 17.18 0 0 0 -11.78 -27.4 l -0.58 5 a 12.16 12.16 0 0 1 8.05 19.69 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 121.715 49.0299)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 121.715 50.83)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -4.784999999999997,
    y1: 0,
    x2: 4.784999999999997,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -65.9082 -136.453)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-184.0917, -113.547)",
    d: "M 185.56 107.07 s -6.1 2.35 -7.86 5.45 c -1.11 1.88 -0.1 5.86 4.27 7.38 c 1.88 0.67 4.58 -0.19 7.62 -1.29 S 190 105.69 185.56 107.07 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -65.875 -135.7883)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(57,153,248)",
      fillRule: "nonzero",
      opacity: 0.5
    },
    transform: " translate(-184.125, -114.2117)",
    d: "M 183.52 118.92 s -4 -0.84 -4 -4.16 s 5.37 -5.38 6.91 -5.38 s 2.3 1.54 2.3 4.1 S 185.73 119.77 183.52 118.92 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -131.0201 -100.4014)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-118.98, -149.5986)",
    d: "M 109.4 125.38 l 10.85 35 l -1.44 7.91 l 4 5.75 l 1.44 -0.72 l 0.72 -5.4 v -4.31 l 1.8 5.75 l 1.79 -1.11 l -1.1 -8.27 l -3.6 -5.76 l -5 -27.3 S 114 124.41 109.4 125.38 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -128.775 -79.65)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.5531,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 1.384999999999998,
    y1: 3.1400000000000006,
    x2: -1.384999999999998,
    y2: -3.1400000000000006
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -126.9751 -80.485)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.5531,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 1.1450000000000031,
    y1: 3.7550000000000097,
    x2: -1.1450000000000031,
    y2: -3.7550000000000097
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -50.7377 -119.6412)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.8297,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-199.2624, -130.3588)",
    d: "M 189.71 112.05 l 19.64 24.72 l 6.13 5.2 l 0.6 7 l -1.58 0.36 l -4 -3.71 l -2.74 -3.32 l 2.27 5.53 l -2.08 0.31 L 203.55 141 l 0.09 -4.89 l -20.12 -17.22 c -1.66 -1.44 -1.34 -5.73 0.56 -6.83 A 6.27 6.27 0 0 1 189.71 112.05 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -36.9851 -104.99)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.5531,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 2.404999999999987,
    y1: 4.230000000000004,
    x2: -2.404999999999987,
    y2: -4.230000000000004
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -35.815 -106.155)",
    id: "freepik--character-2--inject-99"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(38,50,56)",
      strokeWidth: 0.5531,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: 1.0949999999999989,
    y1: 2.335000000000008,
    x2: -1.0949999999999989,
    y2: -2.335000000000008
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 500 500)",
    id: 316235
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(11 0 0 11 739.322 732.2438)",
    id: 92013
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(136,194,251)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.1202 0 0 4.1202 741.8222 732.244)",
    id: 41929
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-14, -14)",
    d: "M 11 4.54125 C 8.11878 5.68927 6.0772 8.44184 6.07706 11.6767 V 17.9802 L 3.31773 20.658 C 3.12222 20.8387 3 21.0961 3 21.3818 V 21.5114 C 3 22.6045 3.89543 23.4906 5 23.4906 H 10.0255 C 10.2508 25.4654 11.9443 27 14 27 C 16.0557 27 17.7492 25.4654 17.9745 23.4906 H 23 C 24.1046 23.4906 25 22.6045 25 21.5114 V 21.382 C 25.0001 21.0963 24.8779 20.8388 24.6823 20.658 L 21.9232 17.9805 V 11.677 C 21.9231 8.44206 19.8814 5.6891 17 4.54114 V 3.47401 C 17 2.18459 15.9963 1.54919 15.6019 1.354 C 15.0885 1.09988 14.5194 1 14 1 C 13.4806 1 12.9115 1.09988 12.3981 1.354 C 12.0037 1.54919 11 2.18459 11 3.47401 V 4.54125 Z M 14.927 3.96881 C 14.9218 3.98589 14.9164 4.00272 14.9108 4.0193 C 14.6118 3.98595 14.308 3.96881 14.0001 3.96881 C 13.6922 3.96881 13.3883 3.98596 13.0893 4.01933 C 13.0836 4.00274 13.0782 3.9859 13.073 3.96881 H 13 V 3.47401 C 13 3.20076 13.4473 2.97921 14 2.97921 C 14.5527 2.97921 15 3.20076 15 3.47401 V 3.96881 H 14.927 Z M 15.9483 23.4906 H 12.0517 C 12.2572 24.3674 13.0515 25.0208 14 25.0208 C 14.9485 25.0208 15.7428 24.3674 15.9483 23.4906 Z M 8.07706 11.6767 C 8.07722 8.53096 10.7105 5.94802 14.0001 5.94802 C 17.2898 5.94802 19.9231 8.53096 19.9232 11.6767 H 8.07706 Z M 8.07706 11.6767 H 19.9232 V 17.9805 C 19.9232 18.5121 20.1393 19.0214 20.5229 19.3936 L 22.7052 21.5114 H 5.29484 L 7.77028 19.1091 C 7.95901 18.9296 8.07706 18.6772 8.07706 18.3958 V 11.6767 Z",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsIconDark);
export default __webpack_public_path__ + "static/media/statistics-icon-dark.425b55623cb2af09e74ba648376e65de.svg";
export { ForwardRef as ReactComponent };